define([
    'WebCommon/event-bus',
    'WebCommon/events',
    'WebCommon/utils',
    'lodash'
], function(
    EventBus,
    Events,
    Utils,
    _
){
    function ln2br(str){
        return (str||'').replace(/\n/g,'<br/>');
    }

    function uniqueId(){
        return Math.random().toString(36).substr(2, 4) + Date.now().toString(36);
    }

    function genGroceryDetailLink(id){
        return Utils.genPageLink('/grocery-detail?id='+id);
    }
    function genFurnitureDetailLink(id){
        return Utils.genPageLink('/furniture-detail?id='+id);
    }
    function genGalleryDetailLink(id){
        return Utils.genPageLink('/gallery-detail?id='+id);
    }

    function genGroceryL2Link(bom){
        return Utils.genPageLink('/grocery-l2?bom='+bom);
    }

    function genFurnitureL2Link(bom){
        return Utils.genPageLink('/furniture-l2?bom='+bom);
    }

    function genProductDetailLink(id, type){
        switch(parseInt(type)){
            case 1:
                return genFurnitureDetailLink(id);
            case 2:
                return genGroceryDetailLink(id);
            case 3:
                return genGalleryDetailLink(id);
            default:
                return genGroceryDetailLink(id);
        }
    }

    function getSkuMainImage(sku){
        var options = {
            color: sku.bgColorBase64,
            width: 500
        };
        return Utils.genFnjiImageUrl(sku.mainImage, options) || Utils.genCdnImageUrl(sku.mainImg, options);
    }
    function getSkuBgColor(sku){
        return sku.bgColor || '#f7f7f7';
    }
    function isSkuSoldOut(sku){
        return parseInt(sku.storeNum) <= 0;
    }
    function isSkuDiscount(sku){
        return sku.discountRate && parseFloat(sku.discountRate) > 0;
    }

    return _.assign({}, Utils, {
        ln2br: ln2br,

        genGroceryDetailLink: genGroceryDetailLink,
        genFurnitureDetailLink: genFurnitureDetailLink,
        uniqueId: uniqueId,
        genProductDetailLink: genProductDetailLink,
        getSkuMainImage: getSkuMainImage,
        getSkuBgColor: getSkuBgColor,
        genGroceryL2Link: genGroceryL2Link,
        genFurnitureL2Link: genFurnitureL2Link,
        isSkuSoldOut: isSkuSoldOut,
        isSkuDiscount: isSkuDiscount

    });
});


//////////////////
// WEBPACK FOOTER
// ./fnjihome2021-detail/common/utils.js
// module id = 106
// module chunks = 1 2 3